import dayjs from 'dayjs';

import Icon from 'atoms/icon';
import { isNotEmptyArray } from 'util';

export default function Vaccinations({ vaccinations, onEdit }) {
  return (
    <div className="vaccinations-panel flex-column mb-12 p-24 border-light-purple radius-24">
      <div className="flex-row justify-between">
        <h4>Vaccinations</h4>
        {onEdit && <Icon name="pencil" className="ml-8" onClick={onEdit} />}
      </div>
      {isNotEmptyArray(vaccinations) ? (
        <>
          <div className="flex-row justify-between mt-16">
            <p className="f13 bold">Type</p>
            <p className="f13 bold">Expiration</p>
          </div>
          {vaccinations.map((vaccination) => (
            <div
              className="flex-row justify-between mt-16"
              key={vaccination.id}
            >
              <p className="f12">{vaccination.value}</p>
              <p className="f12">
                {vaccination.expirationDate
                  ? dayjs(vaccination.expirationDate).format('MMMM D, YYYY')
                  : '-'}
              </p>
            </div>
          ))}
        </>
      ) : (
        <p className="f13 mt-16">
          There are no vaccination records on file. Please edit to add them.
        </p>
      )}
    </div>
  );
}
